import { render, staticRenderFns } from "./Revenue.vue?vue&type=template&id=1aca07d5"
import script from "./Revenue.vue?vue&type=script&lang=js"
export * from "./Revenue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports